<template>
  <div v-if="isPage" class="res-page">
    <div class="gs-page-hero">
      <div class="gs-hero-art is-resources" aria-hidden="true"></div>
      <div class="gs-page-hero-inner">
        <div>
          <h1>行业资料</h1>
          <p>政策、白皮书与研究报告。点击卡片即可下载。</p>
        </div>
      </div>
      <div class="gs-page-hero-metrics">
        <div v-for="item in heroStats" :key="item.label" class="gs-page-hero-metric">
          <div class="metric-num"><em>{{ item.value }}</em>{{ item.unit }}</div>
          <div class="metric-label">{{ item.label }}</div>
        </div>
      </div>
    </div>

    <div class="res-load" v-loading="loading">
    <div class="res-toolbar">
      <span class="res-filter-label">资料类型</span>
      <div class="res-chips">
        <button
          v-for="item in filterOptions"
          :key="String(item.value)"
          type="button"
          class="res-chip"
          :class="{ 'is-active': newsType === item.value }"
          @click="setType(item.value)"
        >{{ item.label }}</button>
      </div>
    </div>

    <div v-if="fileList.length" class="res-grid">
      <article
        v-for="item in fileList"
        :key="item.id"
        class="res-card"
        @click="fileUpload(item)"
      >
        <div class="res-cover">
          <img v-if="coverSrc(item)" :src="coverSrc(item)" :alt="item.name">
          <DocCover v-else fluid class="res-cover-doc" :title="item.name" />
          <span class="res-tag">{{ typeLabel(item.type) }}</span>
        </div>
        <div class="res-body">
          <h2>{{ item.name }}</h2>
          <div class="res-meta">
            <span>{{ dateText(item.createTime) }}</span>
            <button type="button" class="res-dl" @click.stop="fileUpload(item)">下载</button>
          </div>
        </div>
      </article>
    </div>
    <div v-else class="res-empty">
      <NoData />
    </div>
    <GsPagination
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      @current-change="handlePage"
    />
    </div>
  </div>

  <div v-else class="industry-block">
    <div class="top new-top">
      <div class="display-flex center-flex">
        <img src="@/assets/images/ziliaoku-3@2x.png" alt="" class="icon">
        <span class="title-text">行业资料</span>
      </div>
      <div class="ZcFileTop">
        <PillFilter
          v-model="newsType"
          :options="filterOptions"
          :more-text="showMore ? '查看更多' : ''"
          @change="radioChange"
          @more="moreDetail"
        />
      </div>
    </div>
    <div
      class="carousel-container"
      @mouseenter="pauseAnimation"
      @mouseleave="resumeAnimation"
    >
      <button
        class="carousel-btn carousel-btn-prev"
        @click="prevSlide"
        :disabled="fileList.length <= visibleItems"
        v-show="!isNarrow && fileList.length > visibleItems"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="carousel-wrapper" ref="carouselWrapper">
        <div
          class="carousel-track"
          ref="carouselTrack"
          :style="trackStyle"
        >
          <div
            v-for="(item, index) in displayItems"
            :key="`${item.id}-${index}`"
            class="file-marquee gs-card"
            @click="fileUpload(item)"
          >
            <div
              class="file-marquee-item flex flex-col items-center justify-between cursor-pointer"
              :style="opacityImg(item)"
            >
              <DocCover v-if="!coverSrc(item)" fluid class="marquee-doc" :title="item.name" />
            </div>
            <div class="FJFontItem">{{ item.name}}</div>
            <div class="display-flex space-between center-flex pd10">
              <p class="date-item opa6">{{ dateText(item.createTime) }}</p>
              <img src="@/assets/images/xiazai-13 2@2x.png" alt="" class="xiazai" @click.stop="fileUpload(item)">
            </div>
          </div>
        </div>
      </div>

      <button
        class="carousel-btn carousel-btn-next"
        @click="nextSlide"
        :disabled="fileList.length <= visibleItems"
        v-show="!isNarrow && fileList.length > visibleItems"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div v-if="loading && fileList.length < 1" class="industry-empty">
        <GsSkeleton :rows="2" variant="card" />
      </div>
      <div v-else-if="fileList.length < 1" class="industry-empty">
        <NoData />
      </div>
    </div>
  </div>
</template>

<script>
import { getBookList } from "@/api/api";
import NoData from '@/components/NoData/index.vue'
import PillFilter from '@/components/PillFilter/index.vue'
import GsPagination from '@/components/GsPagination/index.vue'
import DocCover from '@/components/DocCover/index.vue'
import { P } from '@/router/paths'

export default {
  name: 'IndustryInfoIndex',
  components: { NoData, PillFilter, GsPagination, DocCover },
  data() {
    return {
      fileList: [],
      newsType: "all",
      prodUrl: "https://shujuzichan.com/xwzx",
      offset: 0,
      isNarrow: typeof window !== 'undefined' && window.innerWidth < 960,
      itemWidth: window.innerWidth < 960 ? 118 : 205,
      visibleItems: window.innerWidth < 960 ? 3 : 7,
      animationDuration: 50000,
      animationId: null,
      startTime: null,
      pauseTime: null,
      accumulatedPauseTime: 0,
      isPaused: false,
      lastAnimationFrameTime: null,
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      heroStats: [
        { label: '公开资料', value: '-', unit: '份' },
        { label: '政策', value: '-', unit: '份' },
        { label: '白皮书', value: '-', unit: '份' },
        { label: '报告', value: '-', unit: '份' },
        { label: '其它', value: '-', unit: '份' },
        { label: '有封面', value: '-', unit: '份' }
      ]
    };
  },
  computed: {
    isPage() {
      const p = String((this.$route && this.$route.path) || '').replace(/\/+$/, '')
      return p === '/resources' || p === '/IndustryInfo'
    },
    showMore() {
      return !this.isPage
    },
    filterOptions() {
      return [
        { label: this.isNarrow ? '全部' : '全部资料', value: 'all' },
        { label: '政策', value: '1' },
        { label: '白皮书', value: '4' },
        { label: '报告', value: '3' },
        { label: '其它', value: '2' }
      ]
    },
    displayItems() {
      if (this.fileList.length <= this.visibleItems) {
        return this.fileList;
      }
      return [...this.fileList, ...this.fileList.slice(0, this.visibleItems)];
    },
    trackStyle() {
      return {
        transform: `translateX(${-this.offset}px)`,
        transition: this.isPaused ? 'none' : 'transform linear'
      };
    }
  },
  created() {
    this.syncNarrow();
    this.getFileList();
    if (this.isPage) this.loadHeroStats();
  },
  mounted() {
    this.syncNarrow();
    window.addEventListener('resize', this.syncNarrow);
    if (!this.isPage) {
      this.$nextTick(() => {
        this.startAnimation();
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.syncNarrow);
    this.stopAnimation();
  },
  methods: {
    typeLabel(type) {
      const map = { '1': '政策', '4': '白皮书', '3': '报告', '2': '其它' }
      return map[String(type)] || '资料'
    },
    dateText(value) {
      if (!value) return ''
      return String(value).split(' ')[0]
    },
    coverSrc(item) {
      const src = item && item.image
      if (!src || /\.svg(\?|$)/i.test(String(src))) return ''
      if (/^https?:\/\//i.test(src)) return src
      return this.prodUrl + src
    },
    setType(value) {
      if (this.newsType === value) return
      this.newsType = value
      this.currentPage = 1
      this.getFileList(value)
    },
    handlePage(page) {
      this.currentPage = page
      this.getFileList(this.newsType)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    syncNarrow() {
      const narrow = typeof window !== 'undefined' && window.innerWidth < 960
      this.isNarrow = narrow
      this.itemWidth = narrow ? 118 : 205
      this.visibleItems = narrow ? 3 : 7
      if (!this.isPage && this.fileList.length) {
        this.$nextTick(() => this.resetAnimation())
      }
    },
    moreDetail() {
      this.$router.push(P.resources)
    },
    loadHeroStats() {
      getBookList({ pageNum: 1, pageSize: 200 }).then((response) => {
        const rows = (response && response.rows) || []
        const total = (response && response.total) || rows.length
        const count = { '1': 0, '4': 0, '3': 0, '2': 0 }
        let cover = 0
        rows.forEach((item) => {
          const key = String(item && item.type)
          if (count[key] != null) count[key] += 1
          const src = item && item.image
          if (src && !/\.svg(\?|$)/i.test(String(src))) cover += 1
        })
        this.heroStats = [
          { label: '公开资料', value: total, unit: '份' },
          { label: '政策', value: count['1'], unit: '份' },
          { label: '白皮书', value: count['4'], unit: '份' },
          { label: '报告', value: count['3'], unit: '份' },
          { label: '其它', value: count['2'], unit: '份' },
          { label: '有封面', value: cover, unit: '份' }
        ]
      }).catch(() => {})
    },
    getFileList(value) {
      const type = value && value !== 'all' ? value : undefined
      const formData = {
        pageNum: this.isPage ? this.currentPage : 1,
        pageSize: this.isPage ? this.pageSize : 10,
        ...(type && { type })
      };
      this.loading = true
      getBookList(formData).then((response) => {
        this.fileList = (response && response.rows) || [];
        this.total = (response && response.total) || this.fileList.length || 0
        this.loading = false
        if (!this.isPage) this.resetAnimation();
      }).catch(() => {
        this.loading = false
      });
    },
    resetAnimation() {
      this.stopAnimation();
      this.offset = 0;
      this.accumulatedPauseTime = 0;
      this.startAnimation();
    },
    startAnimation() {
      if (this.isPage || this.fileList.length <= this.visibleItems || this.animationId) {
        return;
      }
      this.startTime = performance.now();
      this.lastAnimationFrameTime = this.startTime;
      this.animate();
    },
    animate() {
      if (this.isPaused) {
        return;
      }
      const now = performance.now();
      const elapsed = now - this.startTime - this.accumulatedPauseTime;
      this.offset = (elapsed / this.animationDuration) * (this.fileList.length * this.itemWidth);
      if (this.offset >= this.fileList.length * this.itemWidth) {
        this.offset = 0;
        this.startTime = now;
        this.accumulatedPauseTime = 0;
      }
      this.lastAnimationFrameTime = now;
      if (!this.isPaused) {
        this.animationId = requestAnimationFrame(this.animate);
      }
    },
    pauseAnimation() {
      if (this.fileList.length <= this.visibleItems || this.isPaused) {
        return;
      }
      this.isPaused = true;
      this.pauseTime = performance.now();
    },
    resumeAnimation() {
      if (this.fileList.length <= this.visibleItems || !this.isPaused) {
        return;
      }
      const now = performance.now();
      this.accumulatedPauseTime += now - this.pauseTime;
      this.isPaused = false;
      this.pauseTime = null;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      this.animationId = requestAnimationFrame(this.animate);
    },
    stopAnimation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      this.isPaused = false;
      this.pauseTime = null;
      this.accumulatedPauseTime = 0;
    },
    prevSlide() {
      if (this.fileList.length <= this.visibleItems) {
        return;
      }
      this.pauseAnimation();
      const targetOffset = this.offset - this.itemWidth;
      const finalOffset = targetOffset < 0
        ? (this.fileList.length - 1) * this.itemWidth
        : targetOffset;
      this.smoothTransitionTo(finalOffset, () => {
        setTimeout(() => {
          this.resumeAnimation();
        }, 100);
      });
    },
    nextSlide() {
      if (this.fileList.length <= this.visibleItems) {
        return;
      }
      this.pauseAnimation();
      const targetOffset = this.offset + this.itemWidth;
      const maxOffset = this.fileList.length * this.itemWidth;
      const finalOffset = targetOffset >= maxOffset ? 0 : targetOffset;
      this.smoothTransitionTo(finalOffset, () => {
        setTimeout(() => {
          this.resumeAnimation();
        }, 100);
      });
    },
    smoothTransitionTo(targetOffset, callback) {
      const startOffset = this.offset;
      const distance = targetOffset - startOffset;
      const duration = 500;
      const startTime = performance.now();
      const animateTransition = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        this.offset = startOffset + distance * easeProgress;
        if (progress < 1) {
          requestAnimationFrame(animateTransition);
        } else {
          this.offset = targetOffset;
          if (callback) callback();
        }
      };
      requestAnimationFrame(animateTransition);
    },
    radioChange(value) {
      this.getFileList(value);
    },
    fileUpload(item) {
      if (!item || !item.url) return
      const url = /^https?:\/\//i.test(item.url) ? item.url : this.prodUrl + item.url
      // 跨域资源浏览器会忽略 download 属性，直接在当前页打开 PDF，把 SPA 顶掉；
      // 这类一律新标签页打开，只有同域文件才走下载。
      let external = false
      try {
        external = new URL(url, window.location.href).origin !== window.location.origin
      } catch (e) {
        external = false
      }
      if (external) {
        window.open(url, '_blank', 'noopener')
        return
      }
      const link = document.createElement('a')
      link.href = url
      link.download = `${item.name}`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    opacityImg(item) {
      const src = this.coverSrc(item)
      if (!src) return {}
      if (this.isNarrow) {
        return {
          backgroundImage: `url(${src})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat'
        }
      }
      return {
        backgroundImage: `url(${src})`,
        backgroundSize: "100% 100%"
      };
    }
  }
};
</script>

<style scoped>
.res-page {
  width: 100%;
  padding-bottom: 40px;
}
.res-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 18px 0 20px;
  padding: 14px 18px;
  background: #F2F6FB;
  border-radius: 12px;
}
.res-filter-label {
  flex: 0 0 auto;
  font-size: 14px;
  color: #5B6B82;
}
.res-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.res-chip {
  height: 30px;
  padding: 0 12px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #334155;
  font-size: 13px;
  cursor: pointer;
  font-family: inherit;
}
.res-chip.is-active {
  background: #0165FF;
  color: #fff;
  font-weight: 600;
}
.res-grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 12px;
}
.res-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(17, 24, 36, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.res-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(1, 101, 255, 0.14);
}
.res-cover {
  position: relative;
  aspect-ratio: 3 / 4;
  background: linear-gradient(180deg, #E8F1FF 0%, #F7FAFF 100%);
  overflow: hidden;
}
.res-cover img,
.res-cover-doc {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.res-cover-doc {
  aspect-ratio: auto;
  border-radius: 0;
}
.marquee-doc {
  width: 100%;
  height: 100%;
  aspect-ratio: auto;
  border-radius: 8px;
}
.res-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  height: 22px;
  padding: 0 8px;
  border-radius: 4px;
  background: rgba(1, 101, 255, 0.92);
  color: #fff;
  font-size: 12px;
  line-height: 22px;
}
.res-load {
  position: relative;
  min-height: 240px;
}
.res-body {
  padding: 12px 12px 14px;
}
.res-body h2 {
  margin: 0;
  min-height: 40px;
  font-size: 15px;
  font-weight: 700;
  color: #111824;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.res-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  color: #7B889C;
  font-size: 13px;
}
.res-dl {
  height: 28px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: #EEF4FF;
  color: #0165FF;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
}
.res-empty {
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.items-center {
  display: flex;
  align-items: center;
}
.icon {
  width: 55px;
  height: 45px;
}
.FJFontItem {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 10px;
  width: 90%;
  text-align: left;
  font-weight: 700;
  height: 22px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  font-style: normal;
}
.ZcFileTop {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-left: 24px;
  justify-content: flex-end;
}
.industry-block {
  padding-bottom: 16px;
}
.carousel-container {
  position: relative;
  width: 100%;
  min-height: 268px;
  overflow: visible;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 24px;
}
.industry-empty {
  width: 100%;
  min-height: 268px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.carousel-wrapper {
  overflow: hidden;
  flex: 1;
  width: 100%;
  order: 2;
  padding: 8px 0 20px;
}
.carousel-btn {
  position: relative;
  z-index: 10;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #2196F3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  margin: 0 10px;
  flex-shrink: 0;
}
.carousel-btn:hover {
  background: rgba(255, 255, 255, 1);
  color: #1976D2;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.carousel-btn:active {
  transform: scale(0.95);
}
.carousel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.carousel-btn-prev {
  order: 1;
}
.carousel-btn-next {
  order: 3;
}
.carousel-track {
  display: flex;
  will-change: transform;
}
.file-marquee {
  text-align: center;
  width: 200px;
  min-width: 200px;
  box-shadow: 0px 2px 8px 0px rgba(3, 52, 87, 0.2);
  margin-right: 20px;
  flex-shrink: 0;
  transition: transform 0.28s ease, box-shadow 0.28s ease;
  background: linear-gradient( 180deg, #F6F9FF 0%, #FFFFFF 100%);
  border-radius: 8px 8px 4px 4px;
}
.file-marquee .file-marquee-item {
  height: 190px;
  width: 160px;
  margin: 10px auto;
  padding: 0;
  box-shadow: none;
  border: none;
  border-radius: 8px;
  background-repeat: no-repeat;
  transition: transform 0.35s ease;
}
.file-marquee:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(1, 101, 255, 0.16);
}
.date-item {
  height: 20px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.pd10 {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 12px;
}
.xiazai {
  cursor: pointer;
  width: 16px;
  height: 18px;
}
.top {
  background-image: url('@/assets/images/矩形@2x.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  min-height: 56px;
}
.title-text {
  height: 28px;
  font-family: AlimamaFangYuanTiVF-SemiBold, AlimamaFangYuanTiVF-SemiBold;
  font-weight: bold;
  font-size: 28px;
  color: #111824;
  line-height: 34px;
  text-align: left;
  font-style: normal;
  margin-left: 10px;
}
@media (max-width: 1249px) {
  .res-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
@media (max-width: 960px) {
  .res-page .gs-page-hero {
    margin-bottom: 12px;
  }
  .res-load {
    width: calc(100% - 24px);
    margin: 0 auto;
  }
  .res-toolbar {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    margin: 12px 0 14px;
    gap: 8px;
  }
  .res-filter-label {
    font-size: 12px;
  }
  .res-chip {
    height: 28px;
    padding: 0 10px;
    font-size: 12px;
  }
  .res-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .res-cover {
    aspect-ratio: 3 / 4;
  }
  .res-body {
    padding: 10px 10px 12px;
  }
  .res-body h2 {
    font-size: 13px;
    min-height: 36px;
    line-height: 18px;
  }
  .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .title-text {
    font-size: 15px;
    height: auto;
    line-height: 22px;
  }
  .icon {
    width: 34px;
    height: 28px;
  }
  .ZcFileTop {
    width: 100%;
    margin-left: 0;
    flex: none;
    justify-content: stretch;
  }
  .carousel-container,
  .industry-empty {
    min-height: 0;
    padding: 0;
  }
  .carousel-container {
    min-height: 210px;
    padding-bottom: 8px;
  }
  .carousel-wrapper {
    padding: 4px 0 8px;
    overflow: hidden;
  }
  .file-marquee {
    width: 108px;
    min-width: 108px;
    margin-right: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(3, 52, 87, 0.12);
  }
  .file-marquee:hover {
    transform: none;
  }
  .file-marquee-item {
    height: 128px;
    width: 88px;
    margin: 8px auto 4px;
    background-size: cover !important;
    background-position: center top !important;
  }
  .FJFontItem {
    font-size: 12px;
    height: auto;
    min-height: 32px;
    line-height: 16px;
    padding: 0 6px;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .pd10 {
    padding: 2px 6px 8px;
  }
  .date-item {
    font-size: 10px;
  }
  .xiazai {
    width: 14px;
    height: 14px;
  }
  .carousel-btn {
    display: none !important;
  }
  .industry-block {
    padding-bottom: 8px;
  }
}
</style>
